"use client"

import { toImageSrc } from "@/lib/utils"

import type { ServiceItem as ServiceItemType } from "../types/config"

interface ServiceItemProps {
  service: ServiceItemType
  onClick: () => void
  isActive: boolean
}

export const ServiceItem: React.FC<ServiceItemProps> = ({ service, onClick, isActive }) => {
  const backgroundUrl = service.backgroundImage ? toImageSrc(service.backgroundImage) : null

  return (
    <div
      onClick={onClick}
      className="group cursor-pointer relative flex items-center justify-center flex-col rounded-lg w-[243px] h-[324px]"
      style={{
        background: backgroundUrl
          ? `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)), url(${backgroundUrl})`
          : "linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0))",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: "drop-shadow(0 0 6px rgba(0, 0, 0, 0.3))",
      }}
    >
      {/* Hover/Active Overlay */}
      <div
        className={`absolute inset-0 rounded-lg transition-all duration-300 ease-in field-activity-overlay opacity-0 group-hover:opacity-90 ${isActive ? "!opacity-90" : ""
          }`}
      />

      {/* Content */}
      <div className="relative h-[324px] w-[243px] flex flex-col items-center justify-center p-6 text-center z-10 scale-100 group-hover:animate-[zoom_0.3s_ease-in_forwards]">
        {/* Title */}
        <h3 className="text-white text-base sm:leading-6 leading-[26px] font-black uppercase">{service.title}</h3>
      </div>
    </div>
  )
}
